import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  'vps-free': null,
  'vps-paid': null,
  'monitoring-manual': null,
  rebate: null,
  'rebate-brokers': null,
  classic: null,
  multilevel: null,
  'white-label': null,
  rating: null,
  robot: null,
};

export const faqSlice = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    setFaqVpsFree: (state, action) => {
      state['vps-free'] = action.payload;
    },
    setFaqVpsPaid: (state, action) => {
      state['vps-paid'] = action.payload;
    },
    setFaqMonitoringManual: (state, action) => {
      state['monitoring-manual'] = action.payload;
    },
    setFaqRebate: (state, action) => {
      state['rebate'] = action.payload;
    },
    setFaqRebateBrokers: (state, action) => {
      state['rebate-brokers'] = action.payload;
    },
    setFaqClassic: (state, action) => {
      state['classic'] = action.payload;
    },
    setFaqMultilevel: (state, action) => {
      state['multilevel'] = action.payload;
    },
    setFaqWhiteLabel: (state, action) => {
      state['white-label'] = action.payload;
    },
    setFaqRating: (state, action) => {
      state['rating'] = action.payload;
    },
    setFaqRobot: (state, action) => {
      state['robot'] = action.payload;
    },

    resetFaq: () => initialState,
  },
});

export const {
  setFaqVpsFree,
  setFaqVpsPaid,
  setFaqMonitoringManual,
  setFaqRebate,
  setFaqRebateBrokers,
  setFaqClassic,
  setFaqMultilevel,
  setFaqWhiteLabel,
  setFaqRating,
  setFaqRobot,

  resetFaq,
} = faqSlice.actions;

export default faqSlice.reducer;
